/**
 * eMAR dose statuses, as returned by FWAPI's /emar endpoints, with the colours and
 * labels every eMAR surface uses: the Health tab's Medication Administration card,
 * the Care Management > eMAR report, and (server side) the eMAR PDF.
 *
 * The colours match AbilityHub's eMAR on purpose (AHApp src/utils/medicationStatus.js,
 * plus the eMAR PDFs in AHAPI and FWAPI), so a synced client's chart reads the same in
 * both apps. Change them together.
 */
import moment from 'moment';

export const EMAR_STATUS = {
    onTime: { label: 'Given on time', short: 'Given', color: '#2E7D32', text: '#fff' },
    late: { label: 'Given late', short: 'Given late', color: '#A15E00', text: '#fff' },
    notGiven: { label: 'Not given (reason recorded)', short: 'Not given', color: '#594478', text: '#fff' },
    missed: { label: 'Missed (no record)', short: 'Missed', color: '#C62828', text: '#fff' },
    upcoming: { label: 'Scheduled', short: 'Scheduled', color: '#B0B7BC', text: '#263238' },
    notDue: { label: 'Not due', short: 'Not due', color: 'transparent', text: 'inherit' },
};

export const EMAR_LEGEND_ORDER = ['onTime', 'late', 'notGiven', 'missed', 'upcoming', 'notDue'];

/** The caller's clock, which every /emar request sends: dose times are local wall-clock values. */
export const clientClock = () => ({
    now: moment().format('YYYY-MM-DD HH:mm:ss'),
    tzOffset: moment().utcOffset(),
});

/** Adherence badge colour — the same bands as AbilityHub's eMAR client list. */
export const adherenceColor = (adherence) => {
    if (adherence === null || adherence === undefined) return '#9E9E9E';
    if (adherence >= 90) return '#2E7D32';
    if (adherence >= 75) return '#A15E00';
    return '#C62828';
};

/** Reads the message FWAPI puts on a 4xx, falling back to a generic one. */
export const readApiError = (err, fallback) => err?.response?.data?.message || fallback;
